export default __webpack_public_path__ + "static/media/insta.dd9c6af9.svg";